import React, {Component} from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {hasError: false};
  }

  componentDidCatch() {
    this.setState({hasError: true});
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "20px",
            fontWeight: 700,
            textAlign: "center",
          }}
          className="roboto-bold"
        >
          Something went wrong while loading the chart.
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
